// Shared by the browser editor and the Node PDF generator.
const supported = ['text', 'checkbox', 'radiobutton', 'combobox', 'listbox'];
export function editableWidgets(widgets) {
    return widgets.filter(field => supported.includes(field.type) && field.editable !== false);
}
export function applyFieldValues(pdf, fields, values) {
    for (const [name, value] of Object.entries(values || {})) {
        for (const field of editableWidgets((fields && fields[name]) || [])) {
            const button = ['checkbox', 'radiobutton'].includes(field.type);
            // PDF.js expects a scalar for combo-box appearance generation, including
            // an explicit empty string when clearing the selection.
            const stored = { value: button ? value === field.exportValues
                : field.type === 'combobox' && Array.isArray(value) ? (value.length ? value[0] : '') : value };
            if (field.type === 'text') stored.formattedValue = value;
            pdf.annotationStorage.setValue(field.id, stored);
        }
    }
}
export function collectFieldValues(pdf, fields) {
    const values = Object.create(null);
    for (const [name, widgets] of Object.entries(fields || {})) {
        const editable = editableWidgets(widgets);
        const changed = editable.map(field => ({ field, stored: pdf.annotationStorage.getValue(field.id, {}) }))
            .filter(({ stored }) => Object.hasOwn(stored, 'value'));
        if (!changed.length) continue;
        const type = editable[0].type;
        if (['checkbox', 'radiobutton'].includes(type)) {
            const selected = changed.find(({ stored }) => stored.value === true);
            values[name] = selected ? selected.field.exportValues : 'Off';
        } else {
            const value = changed[0].stored.value;
            values[name] = ['combobox', 'listbox'].includes(type)
                ? (Array.isArray(value) ? [...value] : value === '' ? [] : [value])
                : value;
        }
    }
    return values;
}
